import QRCode from 'qrcode';

export async function createQRCodeImage(data: string): Promise<string> {
  const image = await QRCode.toDataURL(atob(data.toString()), {
    scale: 8,
  });

  return image?.split(',')?.pop() ?? '';
}
